import { useSideMenuContext } from "contexts/SideMenuContext";
import { createHeadingId } from "modules/storyblok/adapters/RichtextAdapter/utils";
import { useRef, useEffect } from "react";
import { HammerIcon } from "styles/icons";
import { ChakraDivider as Divider, ChakraHeading } from "@airhelp/react-ui-components";
import type { SideBarHeadingProps } from "./SideBarHeading.d";

const icons = {
  hammer: <HammerIcon color="primary.500" />,
};

const SideBarHeading = ({ text, icon }: SideBarHeadingProps) => {
  const { addHeading, removeHeading } = useSideMenuContext();
  const headingElem = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    addHeading(headingElem);

    return () => {
      removeHeading(headingElem);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <>
      <Divider color="greyscale.100" my={16} />
      <ChakraHeading ref={headingElem} variant="h2" as="h2" id={createHeadingId(text)} my={6} pt={24} mt={-24}>
        {icons[icon] || ""} {text}
      </ChakraHeading>
    </>
  );
};

export default SideBarHeading;
